import { makeIGuidePrintSection } from '@apps/i-guide';
import { PM2PrintFooterSlot, PM2PrintHeaderSlot } from '@provider/print';

const printIGuideComponent = node => {
  return makeIGuidePrintSection(node.component, {
    header: PM2PrintHeaderSlot,
    footer: PM2PrintFooterSlot
  });
};
const iGuideComponentPaperPrinters = {
  "component-framework.i-guide": printIGuideComponent
};

export { iGuideComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
